export default __webpack_public_path__ + "static/media/ltc-usdt.ca554532.png";